import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DefaultButton } from 'common/components';
import { getProfile } from 'interface/user/_redux/actions';

export const WithdrawalGate = ({ children, enabled }) => {
  const verification = useSelector(state => state.user.profile.bankVerification);
  const dispatch = useDispatch();
  if (!enabled || verification?.eligible !== false) return children;
  return (
    <div style={{ padding: 24 }} role="status">
      <p>
        <FormattedMessage
          id={verification.reason === 'pending' ? 'bankVerificationPendingMessage' : 'bankVerificationRequired'}
        />
      </p>
      <p>
        <Link to="/bank_verification">
          <FormattedMessage id="bankVerificationTitle" />
        </Link>
      </p>
      <DefaultButton textId="bankProofRefresh" onClick={() => dispatch(getProfile.request())} />
    </div>
  );
};

WithdrawalGate.propTypes = { children: PropTypes.node.isRequired, enabled: PropTypes.bool };
WithdrawalGate.defaultProps = { enabled: true };
export default WithdrawalGate;
